import React from "react";
import { InlineWidget } from "react-calendly";
import { Link } from "react-router-dom"; // Import Link

function Schedule() {
  const styles = {
    container: {
      color: "white",
      backgroundColor: "black",
      fontFamily: '"Segoe UI", Arial, sans-serif', // Modern font
      textAlign: "center",
      padding: "20px",
    },
    header: {
      color: "#8A2BE2", // A shade of purple
      margin: "0 0 20px 0",
    },
    paragraph: {
      color: "lightgray",
      marginBottom: "20px",
    },
    calendlyWidget: {
      maxWidth: "600px",
      margin: "0 auto",
      height: "100vh",
    },
    homeLink: {
      color: "#8A2BE2", // Purple color
      textDecoration: "none",
      position: "absolute", // Absolute positioning
      top: 0, // Top of the container
      left: 0, // Left of the container
      padding: "10px", // Optional, for some space around the link
    },
  };

  return (
    <>
      <div style={styles.container}>
        <h1 style={styles.header}>Schedule Here!</h1>
        <p style={styles.paragraph}>
          Below you will find my Calendar link to schedule your sessions
        </p>
        <div style={styles.calendlyWidget}>
          <InlineWidget url="https://calendly.com/garagegymcrofton?hide_gdpr_banner=1" />
          <Link to="/" style={styles.homeLink}>
            Go Back Home
          </Link>{" "}
        </div>

        {/* Add this line */}
      </div>
    </>
  );
}

export default Schedule;
